var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-detail-swiper",class:{
		'hide-promotion-bottom': _vm.ispromotion,
		'has-goods-stock': _vm.isStock <= 0
	}},[_c('product-info',{on:{"mbBodytop":_vm.getmbBodytop,"reviewtop":_vm.getreviewtop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }